import { useQuery } from '@tanstack/react-query'
import { RankExperienceService } from '../services/RankExperienceService'
import { RankQueryKeys } from '@/modules/manage-rank/keys'

export default function useQueryGetRankExperienceSetting() {
	return useQuery({
		queryKey: [RankQueryKeys.RANK_EXPERIENCE_SETTING],
		queryFn: () => RankExperienceService.getRankExperienceSetting(),
	})
}
